import React from 'react';

import { Subtitle as StyledSubtitle } from 'shared/components/StoreListSection/StoreListSection.styles';
import { StoreItemViewModel } from 'shared/types/store';
import { addressLine1, addressLine2 } from 'shared/utils/storeViewModel.utils';

type SubtitleProps = {
  store: StoreItemViewModel;
};

const Subtitle = ({ store }: SubtitleProps) => {
  return (
    <StyledSubtitle variant="footnoteMedium">
      {addressLine1(store)}
      <br />
      {addressLine2(store)}
    </StyledSubtitle>
  );
};

export default Subtitle;
